module.exports = __webpack_public_path__ + "img/user-x-01.37bef8d5.svg";